module.exports = __webpack_public_path__ + "img/indicate_icon_4.494ed674.png";